import React, { useState, useEffect } from "react";
import logo from "../../images/header-landing-pages-logo.svg";
import logoDark from "../../images/header-landing-pages-logo-dark.svg";
import burger from "../../images/header-landing-pages-menu.svg";
import close from "../../images/landing-page-menu-close.svg";
import "./index.css";

const HomeNavbar = ({ path = "", history, menuOpen = false, menuOnClick }) => {
  const [isMobile, setIsMobile] = useState(false);

  const pathname = window.location.pathname;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* Mobile Menu Button (only on mobile) */}
        {isMobile && (
          <button className="mobile-menu-button" onClick={menuOnClick}>
            <img
              src={menuOpen ? close : burger}
              alt={menuOpen ? "Close menu" : "Menu"}
            />
          </button>
        )}

        {/* Logo (always visible) */}
        <div className="navbar-logo-container">
          <img
            src={logoDark}
            alt="incola"
            className="navbar-logo"
            onClick={() => history.push("/")}
          />
        </div>

        {/* Desktop Navigation (hidden on mobile) */}
        {!isMobile && (
          <nav className="desktop-nav">
            <a
              className={`nav-link${path === "/how-it-works" ? " active" : ""}`}
              onClick={() => history.push("/how-it-works")}
            >
              How it Works
            </a>
            <a
              className={`nav-link${path === "/about-us" ? " active" : ""}`}
              onClick={() => history.push("/about-us")}
            >
              About
            </a>
            <a
              className={`nav-link${
                path === "/alternative-options" ? " active" : ""
              }`}
              onClick={() => history.push("/alternative-options")}
            >
              Alternative Options
            </a>
          </nav>
        )}

        {/* Get Started Button (always visible) */}
        <button
          style={{ display: pathname === "/confirm" ? "none" : "block" }}
          className={
            path === "/how-it-works" ? "cta-outline-button" : "cta-button"
          }
          onClick={() => history.push("/")}
        >
          Check My Eligibility
        </button>
      </div>
    </header>
  );
};

export default HomeNavbar;
